import React from 'react';
import { Button, Text } from '@ui';
/**
 * Zero-attachments empty state (E2E-04). Deliberately the opposite of the
 * `DeficienciesStep` convention: the section-header CTA is hidden by the
 * caller and this block carries its own CTA instead.
 */
export function AttachmentsEmptyState({ title, description, ctaLabel, onAdd }) {
    return (React.createElement("div", { className: "building-attachments-table__empty", "data-testid": "attachments-empty-state" },
        React.createElement("i", { className: "fa-light fa-paperclip building-attachments-table__empty-icon", "aria-hidden": "true" }),
        React.createElement(Text, { variant: "medium", as: "h3", className: "building-attachments-table__empty-title" }, title),
        React.createElement(Text, { variant: "body", className: "building-attachments-table__empty-description" }, description),
        React.createElement(Button, { variant: "primary", onClick: onAdd, className: "building-attachments-table__empty-cta" },
            React.createElement("i", { className: "fa-light fa-plus", "aria-hidden": "true" }),
            " ",
            ctaLabel)));
}
